/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ActorDefs from './..\\actor\\defs.defs.js'
import * as LabelDefs from './..\\..\\..\\com\\atproto\\label\\defs.defs.js'
import * as GraphDefs from './..\\graph\\defs.defs.js'

const $nsid = 'app.bsky.notification.listNotifications'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  limit: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(
      /*#__PURE__*/ l.integer({ maximum: 100, minimum: 1 }),
      50,
    ),
  ),
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  seenAt: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ format: 'datetime' }),
  ),
  reasons: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(/*#__PURE__*/ l.string()),
  ),
  priority: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  seenAt: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ format: 'datetime' }),
  ),
  priority: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
  notifications: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref<Notification>((() => notification) as any),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Enumerate notifications for the requesting account. Requires auth. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }

type Notification = {
  $type?: 'app.bsky.notification.listNotifications#notification'
  cid: l.CidString
  uri: l.AtUriString
  author: ActorDefs.ProfileView
  isRead: boolean
  labels?: LabelDefs.Label[]

  /**
   * The reason why this notification was delivered - e.g. your post was liked, or you received a new follower.
   */
  reason:
    | 'like'
    | 'repost'
    | 'follow'
    | 'mention'
    | 'reply'
    | 'quote'
    | 'starterpack-joined'
    | 'verified'
    | 'unverified'
    | 'like-via-repost'
    | 'repost-via-repost'
    | 'subscribed-post'
    | 'contact-match'
    | l.UnknownString
  record: l.LexMap
  indexedAt: l.DatetimeString

  /**
   * The starter pack associated with this notification. Present when the notification is for a follow originating from a starter pack.
   */
  starterPack?: GraphDefs.StarterPackViewBasic
  reasonSubject?: l.AtUriString
}

export type { Notification }

const notification = /*#__PURE__*/ l.typedObject<Notification>(
  $nsid,
  'notification',
  /*#__PURE__*/ l.object({
    cid: /*#__PURE__*/ l.string({ format: 'cid' }),
    uri: /*#__PURE__*/ l.string({ format: 'at-uri' }),
    author: /*#__PURE__*/ l.ref<ActorDefs.ProfileView>(
      (() => ActorDefs.profileView) as any,
    ),
    isRead: /*#__PURE__*/ l.boolean(),
    labels: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<LabelDefs.Label>((() => LabelDefs.label) as any),
      ),
    ),
    reason: /*#__PURE__*/ l.string<{
      knownValues: [
        'like',
        'repost',
        'follow',
        'mention',
        'reply',
        'quote',
        'starterpack-joined',
        'verified',
        'unverified',
        'like-via-repost',
        'repost-via-repost',
        'subscribed-post',
        'contact-match',
      ]
    }>(),
    record: /*#__PURE__*/ l.lexMap(),
    indexedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    starterPack: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<GraphDefs.StarterPackViewBasic>(
        (() => GraphDefs.starterPackViewBasic) as any,
      ),
    ),
    reasonSubject: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'at-uri' }),
    ),
  }),
)

export { notification }
